import { Currency } from "./settings.types";

export interface Order {
  id: any;
  clOrderId: string;
  symbol: string;
  type: OrderType;
  quantity: string;
  price: string;
  slippage: number;
  side: Side;
  timeInForce: TIF;
  currency: Currency;
  orderId: string;
  cumQuantity: string;
  leavesQuantity?: string;
  avxPrice: number;
  status: OrderStatus;
  receivedTime?: string;
  transactionTime?: string;
  tradeDate?: string;
  settleDate?: string;
  clientId?: number;
  dealcodeId?: number;
  dealCode?: string;
  userId?: number;
  user?: string;
  statusReason?: string;
  trades?: Trade[];
  bidOfferSide?: string;
  isWsOrder?: boolean;
  expanded?: boolean;
  liquidation?: boolean;
  roll?: boolean;
  liquidityProvider?: string;
  customRowClass?: string;
  errorMessage?: string
  details?: any;
  disableDetails?: boolean;
  targetStrategy: string;
}

export interface RFEOrder {
  id: number;
  rfeId: number;
  transactTime: string;
  reason: string;
  price: number;
  quantity: number;
  eventType: RFEEventType;
  accepted: boolean;
}

export enum RFEEventType {
  EXEC = 'EXEC',
  NOT_DONE = 'NOT_DONE',
  REQ = 'REQ',
  RES = 'RFS'
}

export interface Trade {
  id: number;
  side: Side;
  symbol: string;
  currency: string;
  ccy1Amount: string;
  ccy2Amount: string;
  ccy2AmountUsd: string
  fillRate: string;
  transactionTime: string;
  tradeId: string;
  orderId: string;
  clOrderId: string;
  tradeDate: string;
  valueDate: string;
  fixingDate: string;
  orderType: OrderType;
  taker?: boolean;
  userId?: number;
  user?: string;
  dealCodeId?: string;
  venue?: string;
  roll?: boolean;
  accountPb?: string;
  counterParty?: string;
  cpPb?: string;
  liquidation?: boolean;
  customRowClass?: string;
  errorMessage?: string;
  counterPartyFillRate?: string;
  spreadUsdPnl?: string;
  spreadConversionRate?: number;
  spreadPnlPositive?: string;
}

export enum OrderType {
  LIMIT = 'LIMIT',
  MARKET = 'MARKET'
}

export enum Side {
  BUY = 'BUY',
  SELL = 'SELL'
}

export enum TradeType {
  BID = 'BID',
  BUY = 'BUY',
  OFFER = 'OFFER',
  SELL = 'SELL'
}

export enum OrderStatus {
  PENDING = 'PENDING',
  NEW = 'NEW',
  PARTIALLY_FILLED = 'PARTIALLY_FILLED',
  PART_DONE = 'PART_DONE',
  FILLED = 'FILLED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
  PAUSED = 'PAUSED',
}

export interface OrderBook {
  price: number;
  size: number;
  cumSize?: number;
  liquidityProvider?: string;
  priceStr?: string;
  firstPart?: string;
  secondPart?: string;
  lastDigit?: string;
  cumSizeStr?: string;
  sizeStr?: string;
  bookCumSize?: string;
  bookSize?: string;
}

export interface TopOfBook {
  symbol: string;
  bestSellPrice: number;
  bestBuyPrice: number;
}

export enum TIF {
  IOC = 'IOC',
  DAY = 'DAY',
}

export interface MarketDataResponse {
  //symbol
  symbol?: string;
  //bids
  bids?: OrderBook[];
  //offers
  offers?: OrderBook[];
}

// used to represent a boolean with 3 states (we add unset)
export enum TriState {
  true = 'true',
  false = 'false',
  unset = 'unset'
}

export enum ExecType {
  CANCEL = 'CANCEL',
  REJECT = 'REJECT',
  TRADE = 'TRADE',
}